import {Box, Image} from 'exsportia-components'
import {FC} from 'react'

import {Instructor} from '../../../api/booking/types'
import {InstructorCard} from '../../../components/instructor-card/instructor-card'
import {LabeledSection} from '../../../ui/components/labeled-section/labeled-section'
import {useLocale} from '../../../utils/i18n'

export const ClassInstructorsSection: FC<{ instructors: Instructor[] }> = ({instructors}) => {
  const {l} = useLocale()
  return (
    <LabeledSection label={l('instructors')}>
      {instructors.map((instructor, index) => (
        <Box mb='8px' key={`instructor-${index}`}>
          <InstructorCard
            name={instructor.name}
            image={<Image width='48px' height='48px' size='contain' src={instructor.profileImage.secure_url} />}
          />
        </Box>
      ))}
    </LabeledSection>
  )
}
